export const FOLDER_INDENTATION_WIDTH = 12;
export const LP_COLUMN_MIN_WIDTH = 84;
export const ROOT_FOLDER_VALUE = "__root__";
